import { autoinject } from "aurelia-framework";
import './comp-theme-toggle.scss';

@autoinject()
export class CompThemeToggle {

    // theme = localStorage.getItem('theme') || 'dark';
    theme = 'dark'; //TEMP Set to dark only
    isChecked = this.theme === 'dark';

    constructor() {}

    attached() {
        this.applyTheme();
    }

    toggleTheme() {
        this.theme = this.theme === 'light' ? 'dark' : 'light';
        localStorage.setItem('theme', this.theme);
        this.applyTheme();
    }
  
    private applyTheme() {
        if (this.theme === 'dark') {
            document.documentElement.classList.add('dark-mode');
        } else {
            document.documentElement.classList.remove('dark-mode');
        }
    }
}